import { FormControl, Grid, InputLabel, MenuItem, Paper, Select } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';

export default function Inail(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const action = "changeInail";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    // const handleChangeTipologia = (e: any) => {
    //     let { name, value } = e.target;
    //     SetTipologia(value);
    //     props.handleChange("resetInail", name, value);
    // }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraSchedaBudget(props, global, name, value, action, true);
    }

    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }

    return (
        <Paper className={gClasses.mainPaper}>


            {/* <FormControl className={gClasses.formControl}>
                <InputLabel htmlFor="D17_n_persone_assicurate">Tipologia</InputLabel>
                <Select aria-label="Tipologia" name="ArtigianoIndustria" value={state.inail.ArtigianoIndustria} onChange={handleChange}>
                    <MenuItem value="Non definito" >Non definito</MenuItem>
                    <MenuItem value="Artigianato">Artigianato</MenuItem>
                    <MenuItem value="Industria e Comercio">Industria e Comercio</MenuItem>
                </Select>
            </FormControl> */}
            {state.contoEconomicoDittaSocieta.tipologia_inail === "Artigianato" ? (
                <React.Fragment>
                    <SectionSubTitle text="Artigianato"></SectionSubTitle>
                    <Grid container direction="column">
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="C19_classe_di_rischio">Classe di rischio</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.inail.C19_classe_di_rischio}
                                inputProps={{ name: 'C19_classe_di_rischio', id: 'C19_classe_di_rischio' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={6}>6</MenuItem>
                                <MenuItem value={7}>7</MenuItem>
                                <MenuItem value={8}>8</MenuItem>
                                <MenuItem value={9}>9</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="D17_n_persone_assicurate">N. Persone assicurate</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.inail.D19_n_persone_assicurate}
                                inputProps={{ name: 'D19_n_persone_assicurate', id: 'D19_n_persone_assicurate' }}
                                onChange={handleChangeSelect}
                            >
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                            </Select>
                        </FormControl>
                        <NumberField
                            name="E19_premio_inail"
                            label="Premio Inail"
                            value={state.inail.E19_premio_inail}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                </React.Fragment>)
                : state.contoEconomicoDittaSocieta.tipologia_inail === "Industria e Comercio" ?
                (
                    <React.Fragment>
                        <SectionSubTitle text="Industria e commercio"></SectionSubTitle>
                        <Grid container direction="column">
                            <NumberField
                                name="C27_tassox1000"
                                label="Tasso x 1000"
                                value={state.inail.C27_tassox1000}
                                className={gClasses.textField}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />
                            <FormControl className={gClasses.formControl}>
                                <InputLabel htmlFor="D25_n_persone_assicurate">N. Persone assicurate</InputLabel>
                                <Select
                                    className={gClasses.select}
                                    value={state.inail.D27_n_persone_assicurate}
                                    inputProps={{ name: 'D27_n_persone_assicurate', id: 'D27_n_persone_assicurate' }}
                                    onChange={handleChangeSelect}
                                >
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                </Select>
                            </FormControl>
                            <NumberField
                                name="E27_premio_inail"
                                label="Premio Inail"
                                value={state.inail.E27_premio_inail}
                                className={gClasses.textFieldReadOnly}
                                readOnly={true}
                            />
                        </Grid>
                    </React.Fragment>)
                : <p></p>
            }
        </Paper>
    )
}